import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TasksRoutingModule } from './tasks-routing.module';
import { TasksListComponent } from './tasks-list/tasks-list.component';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { CoreModule } from '../core/core.module';
import { TasksDetailComponent } from './tasks-detail/tasks-detail.component';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {DropdownModule} from 'primeng/dropdown';
import { TasksHistoryDetailComponent } from './tasks-history-detail/tasks-history-detail.component';
import { CalendarModule } from 'primeng/calendar';
import {SplitButtonModule} from 'primeng/splitbutton';
import {TimelineModule} from 'primeng/timeline';
import { TasksHistoryLineComponent } from './tasks-history-line/tasks-history-line.component';
import { TooltipModule } from 'primeng/tooltip';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { TasksCreateContactComponent } from './tasks-create-contact/tasks-create-contact.component';

@NgModule({
  declarations: [
    TasksListComponent,
    TasksDetailComponent,
    TasksHistoryDetailComponent,
    TasksHistoryLineComponent,
    TasksCreateContactComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    TasksRoutingModule,
    InputTextModule,
    ButtonModule,
    TableModule,
    ConfirmDialogModule,
    DialogModule,
    FormsModule,
    CheckboxModule,
    CoreModule,
    CardModule,
    FontAwesomeModule,
    InputTextareaModule,
    DropdownModule,
    CalendarModule,
    SplitButtonModule,
    TimelineModule,
    TooltipModule,
    TranslateModule
  ],
  exports:[
    TasksListComponent,
    TasksDetailComponent,
    TasksHistoryDetailComponent,
    TasksHistoryDetailComponent,
    TasksHistoryLineComponent
  ]
})
export class TasksModule { }
